import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=9736a21a"
import script from "./DefaultChart.vue?vue&type=script&lang=js"
export * from "./DefaultChart.vue?vue&type=script&lang=js"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=9736a21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports